import CardsAligner from '@mnd-frontend/ui/public/components/wrappers/CardsAligner';
import ContentMaxWidth from '@mnd-frontend/ui/public/components/wrappers/ContentMaxWidth';
import SectionHeader, {} from '@mnd-frontend/ui/public/components/wrappers/SectionHeader';
import { BREAKPOINTS, SPACING_6, SPACING_10 } from '@mnd-frontend/ui/shared/tokens';
import Image from 'next/image';
import type { ComponentProps } from 'react';
import styled from 'styled-components';
import StatCard from './StatCard';
import type { StatCardGridModuleQueryResponseType, StatCardProps } from './index.type';

const ModuleContainer = styled.section`
  position: relative;
  padding-top: ${SPACING_6};
  padding-bottom: ${SPACING_6};

  &:not(:has(> img)) {
    background: #F7F7F9; // @todo: use token */
  }
  
  @media (min-width: ${BREAKPOINTS.MD}px) {
    padding-top: ${SPACING_10};
    padding-bottom: ${SPACING_10};
  }
`;

const BackgroundImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
  display: block;
`;

const formatImageData = ({ image }: StatCardGridModuleQueryResponseType) =>
  ({
    src: image?.node.mediaItemUrl ?? '',
    alt: '',
    width: image?.node.mediaDetails?.width ?? undefined,
    height: image?.node.mediaDetails?.height ?? undefined,
  }) satisfies ComponentProps<typeof Image>;

const StatCardGridModule = ({
  moduleData,
}: { moduleData: StatCardGridModuleQueryResponseType }) => {
  const theme = moduleData.image?.node ? moduleData.theme?.[0] : 'dark';

  return (
    <ModuleContainer>
      {moduleData.image?.node.mediaItemUrl && <BackgroundImage {...formatImageData(moduleData)} />}
      <ContentMaxWidth>
        <SectionHeader
          headline={moduleData.title ?? ''}
          subHeadline={moduleData.description ?? ''}
          colorScheme={theme}
          isSmallFont={
            !!moduleData.isTitleSmallSize?.length && moduleData.isTitleSmallSize[0] === '1'
          }
        />
        <CardsAligner>
          {moduleData.statCards?.map((card, idx) => (
            <StatCard
              key={(card?.label ?? `${idx}`)?.trim()}
              colorScheme={theme}
              {...(card as StatCardProps)}
            />
          ))}
        </CardsAligner>
      </ContentMaxWidth>
    </ModuleContainer>
  );
};

export default StatCardGridModule;
